import React from 'react'
import { ThemeToggler } from 'gatsby-plugin-dark-mode'

export default () => (
  <ThemeToggler>
    {({ theme, toggleTheme }) => (
      <button
        type="button"
        className="theme-toggle"
        aria-label="Toggle dark mode"
        aria-pressed={theme === 'dark'}
        onClick={() => toggleTheme(theme === 'dark' ? 'light' : 'dark')}
      >
        <div className="mode-container">
          <i className="gg-sun"></i>
          <i className="gg-moon"></i>
        </div>
      </button>
    )}
  </ThemeToggler>
)
